"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppLinking = void 0;
const react_native_1 = require("react-native");
const react_native_notifications_1 = require("react-native-notifications");
const LINKING_PREFIXES = [
    'elevate://',
    'https://employee.nextep.com',
    'https://staging.nextep.com',
    'https://qa.nextep.com'
];
function buildDeepLinkFromNotification(notification) {
    const url = notification?.payload?.ActionUrl ??
        notification?.payload?.userInfo?.ActionUrl ??
        notification?.payload?.data?.ActionUrl ??
        null;
    if (typeof url === 'string' && LINKING_PREFIXES.some(p => url.startsWith(p))) {
        return url;
    }
    return null;
}
exports.AppLinking = {
    prefixes: LINKING_PREFIXES,
    config: {
        screens: {
            Content: {
                path: '',
                screens: {
                    HomeTab: {
                        path: 'home',
                        screens: {
                            Home: '',
                            MyInformation: 'information',
                            MyBenefits: 'benefits',
                            MyPay: 'pay',
                            PayStubs: 'pay/stubs',
                            PayStubDetail: 'pay/stubs/detail/:voucherId',
                            MyTaxes: 'pay/taxes',
                            HolidaySavingsHistory: 'pay/holidaysavings/history',
                            TimeAttendance: 'time',
                            EmployeeDiscounts: 'discounts',
                            CompanyOnboarding: 'onboarding',
                            LaborLawPosters: 'laborlawposters',
                            OrgChart: 'orgchart',
                            Documents: 'documents',
                            UpdateTaxes: 'pay/taxes/update'
                        }
                    },
                    CompanyTab: {
                        path: 'company',
                        screens: {
                            Company: ':action?',
                            CompanyEmployees: 'employees',
                            CompanyEmployeeDetail: 'employees/:employeeId',
                            CompanyApprovals: 'approvals',
                            CompanyPayrollProcess: 'payroll/process',
                            CompanyPayrollApproval: 'payroll/approval',
                            CompanyPayrollHistory: 'payroll/history',
                            CompanyDocuments: 'documents',
                            CompanyReports: 'reports',
                            CompanySettings: 'settings',
                            CompanyOnboarding: 'onboarding',
                            EmployeeManagement: 'employeemanagement',
                            PtoApprovals: 'ptoapprovals',
                            PtoBalances: 'ptoapprovals/balances',
                            BenefitRenewal: 'benefitrenewal',
                            EditSpendingAccount: 'benefits/spendingaccount/edit',
                            MaryYearInReview: 'yearinreview',
                            CompanyCalendar: 'calendar',
                            OrgChart: 'orgchart',
                            Handouts: 'handouts',
                            EmployeeDetails: 'employeemanagement/employeedetails',
                            LocationDetails: 'employeemanagement/locationdetails',
                            PositionDetails: 'employeemanagement/positiondetails',
                            WorkersCompCertificateRequest: 'risk/wc/certificate',
                            CompanyEnrollmentStatus: 'enrollmentstatus'
                        }
                    },
                    ApprovalsTab: {
                        path: 'ptoapprovals',
                        screens: {
                            PtoApprovals: '',
                            EmployeeDetails: 'employeemanagement/employeedetails'
                        }
                    },
                    HelpTab: {
                        path: 'help',
                        screens: {
                            Help: ''
                        }
                    },
                    SettingsTab: {
                        path: 'settings',
                        screens: {
                            Settings: ''
                        }
                    }
                }
            },
            Login: 'login',
            Register: 'register',
            WebScreen: 'web',
            CompanyDetails: 'company/details',
            CompanySwitch: 'settings/select',
            MultiFactorAuth: 'settings/mfa',
            ChangePassword: 'settings/password',
            ChangeUsername: 'settings/username',
            ChangeTheme: 'settings/theme',
            DirectDepositAddEdit: 'home/pay/deposit/update',
            AnnouncementEdit: 'company/announcement/update',
            AddEmployee: 'company/employeemanagement/addemployee',
            AddLocation: 'company/employeemanagement/addlocation',
            AddPosition: 'company/employeemanagement/addposition',
            AddSettingsCode: 'company/settings/code',
            RehireEmployee: 'company/employeemanagement/rehireemployee',
            TerminateEmployee: 'company/employeemanagement/terminateemployee',
            PtoApprovalAction: 'company/ptoapprovals/respond',
            PtoRequest: 'time/request',
            DependentsEdit: 'home/information/dependents/update',
            PersonalInfoEdit: 'home/information/personalinfo/update',
            EmergencyContactAddEdit: 'home/information/emergencycontact/update',
            HolidaySavingsEdit: 'home/pay/holidaysavings/update',
            HolidaySavingsStop: 'home/pay/holidaysavings/stop',
            HolidaySavingsInfo: 'home/pay/holidaysavings/info',
            CreateCase: 'help/case',
            ScheduleMeeting: 'help/schedule',
            BenefitPopupScreen: 'home/benefits/benefitpopup',
            NotificationSettingsEdit: 'settings/notifications',
            EmailNotificationSettingsEdit: 'settings/notifications/email',
            OshaLogsRequest: 'company/risk/osha/log',
            WorkersCompClaimSubmit: 'company/risk/wc/claim',
            PtoRequestEdit: 'time/requestedit',
            PayRateChangeThreshold: 'company/companysettings/payratechangethreshold',
            AddLifeEvent: 'home/benefits/lifeevent',
            CalendarStreamEdit: 'settings/calendar',
            CalendarStreamSettings: 'company/settings/calendar',
            CompanyEmployeeBenefitDetails: 'company/benefits',
            CompanyEmployeePhoto: 'company/employees/photo/:employeeId',
            CompanyEmployeeRetirement: 'company/employees/retirement/:employeeId',
        }
    },
    async getInitialURL() {
        // Normal deep link
        const url = await react_native_1.Linking.getInitialURL();
        if (typeof url === 'string') {
            return url;
        }
        // App opened from quit state via notification
        const notification = await react_native_notifications_1.Notifications.getInitialNotification();
        if (notification) {
            const deepLink = buildDeepLinkFromNotification(notification);
            if (deepLink) {
                react_native_1.DeviceEventEmitter.emit('deepLink.received', deepLink);
                return null;
            }
        }
        return null;
    },
    subscribe(listener) {
        const linkingSubscription = react_native_1.Linking.addEventListener('url', ({ url }) => {
            react_native_1.DeviceEventEmitter.emit('deepLink.received', url);
        });
        const notificationOpened = react_native_notifications_1.Notifications.events().registerNotificationOpened((notification, completion) => {
            const url = buildDeepLinkFromNotification(notification);
            if (typeof url === 'string') {
                react_native_1.DeviceEventEmitter.emit('deepLink.received', url);
            }
            completion();
        });
        return () => {
            linkingSubscription.remove();
            notificationOpened.remove();
        };
    },
    trimHost(url, prefixes) {
        prefixes.forEach(element => {
            url = url.replace(element, '');
        });
        return url;
    }
};
